/* Split from ruckstuhl-fixes.js; function-scoped loading for performance. */
/* Ruckstuhl V8 RC16 – robuste PORTA-Auswahl, Abschluss und Vorschau */
(function () {
  'use strict';

  function portaModalFrom(target) {
    return target && target.closest ? target.closest('[data-rk-at-modal][data-rk-porta-version]') : null;
  }

  function nativeSelect(modal, suffix) {
    return modal ? modal.querySelector('[id$="' + suffix + '"]') : null;
  }

  function setSelectValue(select, value) {
    if (!select || value == null) return false;
    var wanted = String(value);
    var option = Array.prototype.find.call(select.options || [], function (item) {
      return String(item.value || '') === wanted;
    });
    if (!option) return false;
    select.value = option.value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function reinforceSelection(event) {
    var modal = portaModalFrom(event.target);
    if (!modal) return;

    var colorCard = event.target.closest('.rk-at-color-option[data-color-value]');
    if (colorCard) {
      setSelectValue(nativeSelect(modal, '-color-select'), colorCard.dataset.colorValue);
      return;
    }

    var edgingCard = event.target.closest('.rk-at-edging-type-card[data-edging-value]');
    if (edgingCard) {
      if (modal.dataset.rkAtomicEdging === '1') return;
      setSelectValue(nativeSelect(modal, '-edging'), edgingCard.dataset.edgingValue);
      return;
    }

    var edgingColorCard = event.target.closest('.rk-at-edging-color-option[data-edging-color-value]');
    if (edgingColorCard) {
      if (modal.dataset.rkAtomicEdging === '1') return;
      setSelectValue(nativeSelect(modal, '-edging-color'), edgingColorCard.dataset.edgingColorValue);
    }
  }

  /* Capture sorgt dafür, dass die native Datenquelle bereits vor älteren
     PORTA-Handlern gesetzt ist. Die vorhandenen UI-Handler dürfen danach
     normal weiterlaufen und Preis/Vorschau synchronisieren. */
  document.addEventListener('click', reinforceSelection, true);

  function ensureFinalPage(modal) {
    if (!modal || modal.dataset.rkAtCurrentStep == null) return;
    var activeStep = modal.querySelector('.rk-at-step.is-active[data-rk-at-step="dealer"]');
    if (!activeStep) return;

    var summary = activeStep.querySelector('[data-rk-at-final-summary]');
    if (summary) summary.hidden = false;

    var pdf = activeStep.querySelector('[data-rk-at-final-pdf]');
    var buy = activeStep.querySelector('[data-rk-at-final-buy]');
    if (pdf) pdf.hidden = false;
    if (buy) buy.hidden = false;
  }

  function ensureVisibleFinalFromEvent(event) {
    var modal = portaModalFrom(event && event.target);
    if (modal) window.requestAnimationFrame(function () { ensureFinalPage(modal); });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-rk-at-next],[data-rk-at-progress-index],[data-rk-at-final-pdf],[data-rk-at-final-buy]')) return;
    ensureVisibleFinalFromEvent(event);
  }, true);

  document.addEventListener('rk:porta:mode-change', ensureVisibleFinalFromEvent, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-rk-at-modal][data-rk-porta-version]').forEach(ensureFinalPage);
  });
})()
